import { useEffect, useState } from 'react';
import SubscriptionClient from '../../services/SubscriptionClient';
import { SubscriptionStateResponse } from '../../types/subscription';

const useSubscriptionDataFetcher = (
  authProvider: any, // eslint-disable-line @typescript-eslint/no-explicit-any
  stack: any, // eslint-disable-line @typescript-eslint/no-explicit-any
  subscriptionId: string
) => {
  const [subscriptionData, setSubscriptionData] =
    useState<SubscriptionStateResponse | null>(null);
  const [subSuccess, setSubSuccess] = useState(false);
  const [subError, setSubError] = useState(false);
  const [subLoading, setSubLoading] = useState(false);

  useEffect(() => {
    async function fetchData() {
      setSubLoading(true);
      setSubError(false);
      setSubSuccess(false);

      const subscriptionsClient = new SubscriptionClient(authProvider, stack);

      try {
        const data =
          await subscriptionsClient.getSubscriptionById(subscriptionId);
        setSubscriptionData(data);
        setSubSuccess(true);
        setSubError(false);
      } catch (e) {
        setSubError(true);
        setSubSuccess(false);
        console.log('Error', e);
      } finally {
        setSubLoading(false);
      }
    }
    subscriptionId && fetchData();
  }, [authProvider, stack, subscriptionId]);

  return { subscriptionData, subSuccess, subError, subLoading };
};

export default useSubscriptionDataFetcher;
